<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="'التقارير'"
          :description="'عملبات نقل المشروعات حسب المنتج.'"
        />
        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">
              <i class="fal fa-edit"></i>
              خيارات التقرير
            </h4>
          </div>
          <div class="card-body">
            <div class="row">
              <searchInput
                class="col-md-3"
                title="العميل"
                plaseholder="اختر عميل"
                :show="'name'"
                :refrance="'id'"
                v-model="params.customer_id"
                :value="params.customer_id"
                :values="$database.customers"
              />
              
              <dateFilter class="col-md-3" />

              <searchInput
                class="col-md-3"
                title="المستخدم"
                plaseholder="اختر مستخدم"
                :show="'name'"
                :refrance="'id'"
                v-model="params.user_id"
                :value="params.user_id"
                :values="this.users"
              />
              <searchInput
                class="col-md-3"
                title="المشروع"
                plaseholder="اختر مشروع"
                :show="'name'"
                :refrance="'id'"
                v-model="params.project_id"
                :value="params.project_id"
                :values="$database.projects"
              />
              <searchInput
                class="col-md-3"
                title="من مخزن"
                plaseholder="اختر مخزن"
                :show="'name'"
                :refrance="'id'"
                v-model="params.from_store_id"
                :value="params.from_store_id"
                :values="$database.stores"
              />

              <searchInput
                class="col-md-3"
                title="إلي مخزن"
                plaseholder="اختر مخزن"
                :show="'name'"
                :refrance="'id'"
                v-model="params.to_store_id"
                :value="params.to_store_id"
                :values="$database.stores"
              />
              
              
              <searchInput
                class="col-md-3"
                title="المنتج"
                plaseholder="اختر منتج"
                :show="'name'"
                :refrance="'id'"
                v-model="params.product_id"
                :value="params.product_id"
                :values="$database.products"
              />
              <searchInput
                class="col-md-3"
                title="تصنيف المنتجات"
                plaseholder="اختر تصنيف"
                :show="'name'"
                :refrance="'id'"
                v-model="params.section_id"
                :value="params.section_id"
                :values="$database.sections"
              />
              <actionButtons class="col-md-3" />
            </div>
          </div>
        </div>
        <div id="reportShow">
          <reportHeader 
            title="نقل المشروعات حسب المنتج" 
            :details="[
              {title: 'اسم المستخدم', value : userName },
              {title: 'من مخزن', value : fromStoreName },
              {title: 'إلي مخزن', value : toStoreName },
              {title: 'المشروع', value : projectName },
              {title: 'المنتج', value : productName },
              {title: 'التصنيف', value : sectionName },
            ]"
          />
          <reportTable
            :emptyTableText="'لايوجد بيانات حاليا'"
            :emptyTableSubText="'جرب اضافة البعض واعد المحاولة'"
            :cloumns="[
              { column: 'product_name', link: '/products', title:'اسم المنتج' ,type: 'reportMainLink' , sort: true },
              { column: 'quantity', title: 'الكمية', type: 'text', sort: true },
              {
                column: 'average',
                title: 'المتوسط',
                type: 'text',
                sort: true,
                supData: true,
              },
              {
                column: 'price',
                title: 'الأجمالي',
                type: 'text',
                sort: true,
              },
            ]"
            :footer="[
              { colspan: 1, value: 'المجموع' },
              { colspan: 1, value: quantity },
              {
                colspan: 1,
                value: average,
                supData: true,
              },
              { colspan: 1, value: price},
            ]"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

import reportHeader from "../../elements/reports/reportHeader.vue";
import reportTable from "../../elements/reports/reportTable.vue";
import indexHeader from "../../elements/index/indexHeader.vue";
import dateFilter from "../../elements/reports/dateFilter.vue";
import searchInput from "../../elements/reports/searchInput.vue";
import actionButtons from "../../elements/reports/actionButtons.vue";

export default {
  data() {
    return {
      path: "/reports/projectsTransfers/products",
      items: [],

      loading: 0,

      quantity: 0,
      price: 0,
      average: 0,
      earning: 0,

      params: {
        from_store_id: "",
        to_from_store_id: "",
        user_id: "",
        project_id: "",
        startDate: '',
        endDate: ''
      },

      excel: {
        fileName: 'project transfers by items',
        reportData: '[]'
      },

      users: [],
      fromStoreName:"",
      toStoreName:"",
      projectName:"",
      userName:"",
      productName: "",
      sectionName: "",

      searchStartDate: "",
      searchEndDate: "",
    };
  },
  methods: {
    getData() {
      this.$setParams(this.params);
      this.loading = 1;
      this.items = [];
      axios
        .get(this.$linkGnirator(this.path), { params: this.params })
        .then((response) => {

          this.searchStartDate = this.params.startDate;
          this.searchEndDate = this.params.endDate;

          this.quantity = 0;
          this.price = 0;
          this.average = 0;

          this.items = [];
          response.data.forEach((item) => {
            var mitem = this.items.find(
              (el) =>
                el.product_id == item.product_id &&
                el.detail_id == item.detail_id
            );
            if (typeof mitem === "undefined") {
              item.price = item.price * item.quantity;
              this.items.push(item);
              var mitem = this.items.find(
                (el) =>
                  el.product_id == item.product_id &&
                  el.detail_id == item.detail_id
              );
            } else {
              mitem.quantity += item.quantity;
              mitem.price += item.price * item.quantity;
            }
            mitem.average = mitem.price != 0 ? Math.ceil(mitem.price / mitem.quantity) : 0;
            this.average += mitem.average;
            mitem.average = mitem.average.toFixed(2);
          });
          this.items.forEach((item) => {
            item.id = item.product_id
            this.quantity += item.quantity;
            this.price += item.price;
            item.price = this.$moneyFormat(item.price)
            

          });
          this.average = this.$moneyFormat(this.average)
          this.price = this.$moneyFormat(this.price)
          this.loading = 0;
        });

      var project = this.$database.projects.find((el) => el.id == this.params.project_id);
      if (project) {
        this.projectName = project.name;
      } else{
        this.projectName = ""
      }

       var fromStore = this.$database.stores.find((el) => el.id == this.params.from_store_id);
      if (fromStore) {
        this.fromStoreName = fromStore.name;
      } else{
        this.fromStoreName = ""
      }

      var toStore = this.$database.stores.find((el) => el.id == this.params.to_store_id);
      if (toStore) {
        this.toStoreName = toStore.name;
      } else{
        this.toStoreName = ""
      }

       var user = this.users.find((el) => el.id == this.params.user_id);
      if (user) {
        this.userName = user.name;
      } else{
        this.userName =""
      }


      var product = this.$database.products.find((el) => el.id == this.params.product_id);
      if (product) {
        this.productName = product.name;
      } else{
        this.productName =""
      }

      var section = this.$database.sections.find((el) => el.id == this.params.section_id);
      if (section) {
        this.sectionName = section.name;
      } else{
        this.sectionName =""
      }

    },
    getItems() {
      this.$setParams(this.params);
      if (this.params.orderBy) {
        this.items.sort(this.$dynamicSort(this.params));
      }
    },
    getUsers() {
      axios.get(this.$linkGnirator("/usersItems")).then((response) => {
        this.users = response.data;
      });
    },
  },
  watch: {
    items : function () {
      var mainElemnt = this
      setTimeout(() => {
        var title = document.querySelector('.report-title').textContent
        var data  = document.querySelector('.report-data').textContent
        var date = document.querySelector('.report-date').textContent
        var header = [title, data, date]
        var table = document.querySelector('table')
        var reportData = [...table.rows].map(r => [...r.querySelectorAll('th, td')].map(td => td.textContent))
        reportData.unshift(header)
        mainElemnt.excel.reportData = JSON.stringify(reportData);
      }, 100)
    }
  },
  mounted() {
    this.params = this.$getParams();
    if (typeof this.params.startDate === 'undefined') {
      this.params.startDate = new Date().toISOString('en-US', { timeZone: 'Africa/Cairo' }).slice(0, 10);
    }
    this.getData();
    this.getUsers();
  },
  components: {
    reportHeader,
    reportTable,
    indexHeader,
    dateFilter,
    searchInput,
    actionButtons,
  },
};
</script>
